import React, { useMemo } from 'react'
import { Typography, withStyles } from '@material-ui/core'
import styles from './styles'
import { INITIAL_WIDGET_OPTIONS } from '../constants'
import { useSelector } from 'react-redux'

const DEFAULT_WIDGET_REDIRECT_URL = (process.env.REACT_APP_VIEW_URL?.replace(/\/$/, '') || 'https://share.minicoursegenerator.com') + '/widget-redirect'

const WidgetViewHeader = props => {
  const { widgetType, classes, config } = props
  const widgetData = INITIAL_WIDGET_OPTIONS.find(
    option => option.widgetType === widgetType,
  )
  const user = useSelector(state => state.authentication.me)
  const collection = useSelector(state => state.collection.collection)

  const handleWidgetClick = () => {
    // Close any existing modal or sidebar widgets
    const existingModals = document.querySelectorAll('.mcg-modal-close')
    const existingSidebars = document.querySelectorAll('.mcg-sidebar-close')

    // Close all existing modals
    existingModals.forEach(closeButton => {
      if (closeButton && typeof closeButton.click === 'function') {
        closeButton.click()
      }
    })

    // Close all existing sidebars
    existingSidebars.forEach(closeButton => {
      if (closeButton && typeof closeButton.click === 'function') {
        closeButton.click()
      }
    })
  }

  const buttonAttributes = useMemo(() => {
    if (!user) return null

    // Common attributes for all widget types
    const commonAttributes = {
      id: widgetType === 'direct-link' ? `direct` : `${widgetType}-widget`,
      className: 'widget-button mcg-widget',
      'data-mcg-widget': widgetType === 'direct-link' ? 'direct' : widgetType,
      'data-mcg-collection': collection?.id,
      'data-mcg-title': config.title || widgetData?.label || '',
      // The owning shop's key: a collaborator from another shop has a different one, which
      // widget-redirect rejects.
      'data-mcg-public-key': collection?.publicKey ?? user.publicKey ?? '',
      'data-mcg-user-name': user.email || '',
      'data-mcg-name-surname': user.name + ' ' + user.surname || '',
      'data-mcg-base-url':
        config?.baseUrl ||
        DEFAULT_WIDGET_REDIRECT_URL,
      onClick: handleWidgetClick,
    }

    // Widget-specific attributes
    switch (widgetType) {
      case 'modal':
        return {
          ...commonAttributes,
          'data-mcg-modal-max-width': config.modalMaxWidth || '800px',
          'data-mcg-theme': config.theme || 'light',
          'data-mcg-z-index': config.zIndex || '9999',
          'data-mcg-close-on-click-outside':
            config.closeOnClickOutside || 'true',
        }
      case 'direct':
        return {
          ...commonAttributes,
          'data-mcg-direct-link-target': config.directLinkTarget || '_blank',
          'data-mcg-direct-link-text':
            config.directLinkText || 'Open Documentation',
        }
      case 'sidebar':
        return {
          ...commonAttributes,
          'data-mcg-width': config.width || '400px',
          'data-mcg-position': config.position || 'left',
          'data-mcg-theme': config.theme || 'light',
          'data-mcg-z-index': config.zIndex || '9999',
          'data-mcg-close-on-click-outside':
            config.closeOnClickOutside || 'false',
        }
      default:
        return commonAttributes
    }
  }, [config, widgetType, widgetData?.label, user, collection?.id, collection?.publicKey])

  // Generate a unique key for the button that changes when attributes change
  const buttonKey = useMemo(() => {
    return buttonAttributes
      ? `${widgetType}-${JSON.stringify(buttonAttributes)}`
      : widgetType
  }, [widgetType, buttonAttributes])

  return (
    <div className={classes.root}>
      <Typography fontSize="16px" fontWeight={500}>
        Widget Settings{' '}
      </Typography>
      {widgetType !== 'embed' && buttonAttributes && (
        <button
          key={buttonKey}
          {...buttonAttributes}
          style={{
            backgroundColor: '#015ffb',
            color: '#fff',
            borderRadius: '8px',
            padding: '9px 16px',
            fontWeight: '500',
            cursor: 'pointer',
            border: 'none',
            fontFamily: 'Inter',
          }}
        >
          Preview
        </button>
      )}
    </div>
  )
}

export default withStyles(styles)(WidgetViewHeader)
